var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    {
      ref: "label",
      staticClass: "custom-checkbox",
      class: { "is-disabled": _vm.disabled },
      attrs: { disabled: _vm.disabled, tabindex: _vm.disabled ? false : 0 },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter") &&
            _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
          )
            return null
          $event.preventDefault()
          return _vm.$refs.label.click()
        },
      },
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.newValue,
            expression: "newValue",
          },
        ],
        attrs: {
          type: "checkbox",
          disabled: _vm.disabled,
          name: _vm.name,
          "true-value": _vm.trueValue,
          "false-value": _vm.falseValue,
        },
        domProps: {
          value: _vm.nativeValue,
          checked: Array.isArray(_vm.newValue)
            ? _vm._i(_vm.newValue, _vm.nativeValue) > -1
            : _vm._q(_vm.newValue, _vm.trueValue),
        },
        on: {
          change: function ($event) {
            var $$a = _vm.newValue,
              $$el = $event.target,
              $$c = $$el.checked ? _vm.trueValue : _vm.falseValue
            if (Array.isArray($$a)) {
              var $$v = _vm.nativeValue,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.newValue = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.newValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.newValue = $$c
            }
          },
        },
      }),
      _c("span", { staticClass: "check" }),
      _c("span", { staticClass: "control-label" }, [_vm._t("default")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }